import { render, staticRenderFns } from "./DashboardCardsPendenciasTotalizadores.vue?vue&type=template&id=65bb8448"
import script from "./DashboardCardsPendenciasTotalizadores.vue?vue&type=script&lang=js"
export * from "./DashboardCardsPendenciasTotalizadores.vue?vue&type=script&lang=js"
import style0 from "./DashboardCardsPendenciasTotalizadores.vue?vue&type=style&index=0&id=65bb8448&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports